'use client';

import {useEvent} from '@rocket-ui/react-tools';
import {animatedScrollUp} from '@rocket-ui/tools';
import React, {FC, useEffect, useState} from 'react';
import {ActionsAreaPortal} from '../ActionsArea';
import {IconButton} from '../IconButton';

export interface ScrollUpButtonProps {
	offset?: number;
	shift?: Array<string | number>;
}

export const ScrollUpButton: FC<ScrollUpButtonProps> = React.memo(function ScrollUpButton({offset, shift = [0, 0]}) {
	const [visible, setVisible] = useState(false);
	const [shiftX, shiftY] = shift;

	useEffect(() => {
		function handleScroll() {
			setVisible(window.scrollY > window.innerHeight);
		}

		window.addEventListener('scroll', handleScroll);

		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, [setVisible]);

	const handleScrollUp = useEvent(() => animatedScrollUp({to: offset}));

	if (!visible) return null;

	return (
		<ActionsAreaPortal slide={'bottom'} withBottomMargin>
			<div className={'mx-2'} style={{transform: `translate(${shiftX}, ${shiftY})`}}>
				<IconButton className={'w-auto mr-6'} iconName="arrow-up" theme="gray" roundingSize="medium" onClick={handleScrollUp} circularIcon>
					Наверх
				</IconButton>
			</div>
		</ActionsAreaPortal>
	);
});
